import { render } from "./ConfirmDatenschutz.vue?vue&type=template&id=563c540f"
import script from "./ConfirmDatenschutz.vue?vue&type=script&lang=js"
export * from "./ConfirmDatenschutz.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__